module.exports = __webpack_public_path__ + "img/lxwmnew.715f0527.png";